import {
  defineComponent, h, Suspense, type Component,
} from 'vue';

export const wrapInSuspense = (component: Component) => defineComponent({
  name: `WithSuspense(${component.name || 'Anonymous'})`,
  setup(_, { attrs, slots }) {
    return () => h(
      Suspense,
      null,
      {
        default: () => h(component, attrs, slots),
      },
    );
  },
});
